import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from './components/protected-route';
import Explore from './pages/explore';
import ModelsPage from './pages/models';
import Dashboard from './layouts/dashboard-layout';
import { SuperSplatViewport } from './components/editor/supersplat-viewport';
import ScenesPage from './pages/scenes';
import ArtifactsPage from './pages/artifacts';
import DashboardLogin from './pages/dashboard-login';
import SceneMissing from './pages/scene-missing';
import OAuthConsent from './pages/oauth-consent';

export const router = createBrowserRouter([
  {
    path: "/scene",
    element: <SceneMissing />,
  },
  {
    path: "/oauth/consent",
    element: <OAuthConsent />,
  },
  {
    path: "/scene/:id",
    element: <SuperSplatViewport />,
  },
  {
    path: "/",
    element: <Dashboard />,
    children: [
      {
        index: true,
        element: <Explore />,
      },
      {
        path: "login",
        element: <DashboardLogin />,
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            path: "models",
            element: <ModelsPage />,
          },
          {
            path: "scenes",
            element: <ScenesPage />,
          },
          {
            path: "artifacts",
            element: <ArtifactsPage />,
          },
        ],
      },
    ],
  },
]);
